export default {
  "slug": "voltage-drop-calculation",
  "title": "Fire Alarm Voltage Drop, Explained",
  "description": "What voltage drop is on a fire alarm notification circuit, why it can starve horns and strobes, and how current, conductor size, and run length drive it.",
  "keywords": "fire alarm voltage drop, NAC voltage drop calculation, notification appliance circuit, strobe voltage drop, end of line voltage, fire alarm design",
  "ogImage": "/guide-og/voltage-drop-calculation.jpg",
  "faqs": [
    {
      "q": "What causes voltage drop on a NAC?",
      "a": "Voltage drop is caused by current flowing through the resistance of the conductors. Higher appliance current, smaller wire, and longer runs all increase the drop between the panel and the last appliance."
    },
    {
      "q": "Why does voltage drop matter for horns and strobes?",
      "a": "Notification appliances have a minimum operating voltage. If drop pushes the end-of-line voltage below that minimum, appliances may not produce their rated sound or light output."
    },
    {
      "q": "How do I reduce voltage drop?",
      "a": "Use larger conductors, shorten runs, put fewer appliances on a circuit, or add power extenders — then verify the end-of-line voltage stays within the appliances' listed range."
    }
  ],
  "category": "Systems",
  "readMins": 5,
  "published": "2026-09-27",
  "updated": "2026-09-27",
  "hero": "/guide-hero/voltage-drop-calculation.jpg",
  "heroAlt": "Illustration of a notification appliance circuit with a fading voltage gradient",
  "excerpt": "The last strobe on a long circuit sees less voltage than the panel supplies. Here's why voltage drop happens and how designers stay within limits.",
  "sections": [
    {
      "h": "What is voltage drop?",
      "p": "Voltage drop is the loss of voltage along a conductor as current flows through its resistance. On a long notification appliance circuit (NAC), the last appliance receives less voltage than the panel puts out."
    },
    {
      "h": "Why it matters for NACs",
      "p": "Horns and strobes have a minimum operating voltage. If voltage drop pushes the end-of-line voltage below that minimum, the appliances may not sound or flash at their rated output — a real performance gap."
    },
    {
      "h": "What drives voltage drop",
      "p": "Three factors: the current the appliances draw, the wire's resistance (gauge and length), and the supply voltage. Longer runs, smaller conductors, and heavier loads all increase the drop."
    },
    {
      "h": "Designing within limits",
      "p": "Designers estimate the worst-case end-of-line voltage, then adjust with larger conductors, shorter runs, fewer appliances per circuit, or power extenders. Always check against the listed appliance voltage range and the adopted code."
    }
  ],
  "relatedModules": [
    "wiring-circuitry",
    "circuits",
    "control-panels"
  ],
  "relatedGuides": [
    "fire-alarm-wiring-and-circuits",
    "battery-standby-calculation",
    "notification-appliance-strobe-spacing",
    "fire-alarm-system-design-basics"
  ]
};
